import { render, staticRenderFns } from "./navigation.html?vue&type=template&id=c01f549a&scoped=true&"
import script from "./navigation.js?vue&type=script&lang=js&"
export * from "./navigation.js?vue&type=script&lang=js&"
import style0 from "./navigation.scss?vue&type=style&index=0&id=c01f549a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01f549a",
  null
  
)

export default component.exports